/**
 * Utility functions for generation timing and formatting
 */

// Estimated durations in seconds based on model
const MODEL_DURATIONS: Record<string, number> = {
  // Image models
  qwen_image: 20,
  qwen_image_lora: 25,
  qwen_image_edit: 20,
  // Character creation — wan-2.2 realism endpoint, ~30s in practice.
  wan_2_2_t2i_realism: 30,
  // Basic: WaveSpeed 480p ultra-fast ~1 minute
  ws_480p_i2v_5s: 60,
  wan_2_2_i2v_3s: 60,
  // Standard: WaveSpeed 720p ultra-fast ~1.5-2 minutes
  ws_720p_i2v_5s: 90,
  ws_720p_i2v_10s: 120,
  // Legacy standard (inactive, kept for old generations)
  wan_2_2_i2v_6s: 420,
  wan_2_2_i2v_12s: 420,
  // Premium: Wan 2.5 (480p + 1080p upscale) ~5-7 minutes
  wan_2_5_i2v_5s: 300,
  wan_2_5_i2v_10s: 400,
  // Instant videos (animate) - 3 minutes (480p + 1080p upscale)
  wan_2_2_animate_5s: 200,
  // Text to video - 5 minutes
  wan_2_6_t2v_5s: 320,
};

export function getEstimatedDuration(modelId: string): number {
  return MODEL_DURATIONS[modelId] ?? 300; // Default 5 minutes
}

export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins > 0) {
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }
  return `${secs}s`;
}

export function calculateProgress(
  startTime: number | null,
  modelId: string | undefined,
): number {
  if (startTime === null) return 0;
  if (!modelId) return 50;

  const estimatedDuration = getEstimatedDuration(modelId);
  const elapsed = (Date.now() - startTime) / 1000;
  return Math.min(95, (elapsed / estimatedDuration) * 100);
}

export function calculateTimeRemaining(
  startTime: number | null,
  modelId: string | undefined,
): number | null {
  if (startTime === null) return null;

  const duration = modelId ? getEstimatedDuration(modelId) : 300;
  const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
  return Math.max(0, duration - elapsedSeconds);
}
